import type { IntlShape } from 'react-intl';
import type { SampleDocType } from '@ast-data/shared';
import { formatDate } from '../../utils/formatDate';

/**
 * What names a Probe — it has no number of its own: "Bodenprobe vom
 * 03.10.2026", or "Probe vom 03.10.2026" while its Probenart is still open.
 */
export function sampleLabel(
    intl: IntlShape,
    sample: Pick<SampleDocType, 'sampleType' | 'recordedAt'>
): string {
    const type = sample.sampleType.trim();
    const date = formatDate(sample.recordedAt);
    if (!date) {
        return type || intl.formatMessage({ id: 'sample.labelPlain' });
    }
    return intl.formatMessage(
        { id: type ? 'sample.labelTyped' : 'sample.label' },
        { type, date }
    );
}
